import React, { Component } from 'react'
import Alert from '../../Component/Alert'
import axios from 'axios'
import { Redirect } from 'react-router-dom'
import Config from '../../Constants/index'
import t from '../../Lang/Index'

export default class MatchOrderInsert extends Component {

    constructor() {
        super();
        this.state = {
            teamTitle: '',
            messages: [],
            isSuccess: false
        };

        this.onClick_Btn = this.onClick_Btn.bind(this);
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onClick_Btn = (e) => {
        e.preventDefault();

        if (!this.validate())
            return;

        var messages = [];
        this.setState({ messages });

        var self = this;

        //TODO
        axios.post(Config.API_URL + "Auth/ChangePassword", {
            NewPassword: this.state.newPassword,
            CurrentPassword: this.state.currentPassword
        },
            { headers: { token: window.localStorage.getItem("apiToken") } })
            .then(response => {
                this.setState({ isSuccess: true });
                window.localStorage.setItem("apiToken", "");
            })
            .catch(function (error) {

                if (error.response && error.response.status == 400) {
                    error.response.data.message.map(p => {
                        messages.push(p);
                    })
                }
                else {
                    messages.push("خطا در برقراری ارتباط با سرور - در صورت استفاده از پروکسی آنرا غیر فعال نمایید")
                }
                console.log(error);
                self.setState({ messages, isInsert: true });

            });

    }

    validate = () => {
        var messages = [];
        if (this.state.email.length == 0)
            messages.push("Please complete Email");
        //messages.push("لطفا ایمیل را تکمیل نمایید");

        //if (this.state.email.length > 0 && !isEmail(this.state.email))
        //    messages.push("Email is not correct")
        //messages.push("ایمیل را به صورت صحیح درج نمایید");

        this.setState({ messages: messages });

        return messages.length == 0;

    }

    render() {

        if (this.state.isRedirectToHome) {
            return <Redirect to={'/'} />
        }

        if (this.state.isSuccess) {
            return <div className="alert alert-dismissable alert-success">
                <h4>عملیات موفقیت آمیز!</h4>
                ایمیل بازنشانی کلمه عبور ارسال گردید.
                لطفا ایمیل خود را چک نمایید (ممکن است ایمیل در پوشه Junk ذخیره شده باشد)
         </div>
        }



        return (
            <form role="form" method="post">
                <div className="alert alert-dismissable alert-danger" id="ContentGridAddModalAlertDangerContainer" style={{ display: 'none' }}>
                </div>
                <fieldset>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                            {t.email}
                        </label>
                        <input className="form-control" style={{ direction: 'ltr' }} placeholder="Email"
                            id="Email" name="email" type="email" ref="email" autofocus onChange={this.onChange} />


                    </div>

                    {this.state.messages.length > 0 &&
                        <Alert messages={this.state.messages}></Alert>}

                    {this.state.isInsert ?
                        (<div><button className="btn btn-lg btn-primary btn-block" id="btnLogin" type="button"
                            onClick={this.onClick_Btn}>{t.reset_password}</button>

                        </div>

                        )
                        : (
                            <button className="btn btn-lg btn-primary btn-block disabled" type="button"
                            >
                                <i class='fa fa-spinner fa-spin '></i> {t.loading}</button>)
                    }

                </fieldset>
            </form>
        )
    }
}
